<template>
  <div class="company-detail-container" style="margin-top: 10px;margin-left: 30px;">
    <el-card class="detail-card">
      <div slot="header" class="clearfix">
        <span>企业详情信息</span>
      </div>
      
      <el-descriptions :column="2" border>
        <el-descriptions-item label="企业ID">{{ detailData.companyId }}</el-descriptions-item>
        <el-descriptions-item label="企业名称">{{ detailData.companyName }}</el-descriptions-item>
        <el-descriptions-item label="统一信用代码">{{ detailData.socialCreditCode }}</el-descriptions-item>
        <el-descriptions-item label="企业账号">{{ detailData.userId }}</el-descriptions-item>
        <el-descriptions-item label="认证状态">{{ detailData.authState }}</el-descriptions-item>
        <el-descriptions-item label="账号状态">{{ detailData.state }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ detailData.contactsName }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detailData.contactsPhone }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CompanyDetail',
  data() {
    return {
      detailData: {}
    }
  },
  created() {
    this.detailData = JSON.parse(this.$route.query.formData)
  }
}
</script>

<style scoped>
.company-detail-container {
  padding: 20px;
}
.detail-card {
  margin-top: 20px;
}
</style>